import { useState } from "react";
import { IconButton, IconButtonProps } from "@chakra-ui/react";

interface IconActionButtonProps extends Omit<IconButtonProps, "onClick"> {
  action: () => Promise<void>;
  confirmationMessage?: string;
}

export const IconActionButton = (props: IconActionButtonProps) => {
  const { children, action, confirmationMessage, ...rest } = props;
  const [isLoading, setIsLoading] = useState<boolean>(false);
  return (
    <IconButton
      onClick={async () => {
        if (confirmationMessage) {
          // eslint-disable-next-line
          if (!confirm(confirmationMessage)) {
            return;
          }
        }

        setIsLoading(true);

        const actionWrapper = async () => {
          try {
            await action();
          } finally {
            setIsLoading(false);
          }
        };

        actionWrapper();
      }}
      isLoading={isLoading}
      {...rest}
    >
      {children}
    </IconButton>
  );
};
